import { ref } from 'vue';

const asyncLoading = <T extends (...args: any) => Promise<any>>(promiseFn: T) => {
  const loading = ref(false);
  const fn = async (...args: any[]) => {
    let res: any;
    try {
      loading.value = true;
      res = await promiseFn(...args);
    } finally {
      loading.value = false;
    }
    return res;
  };

  return {
    loading,
    fn,
  };
};
export default asyncLoading;
